import { Outlet } from 'react-router-dom';
import './SimpleLayout.scss';

const SimpleLayout: React.FC = () => {
  return (
    <div className="app-shell">
      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
};

export default SimpleLayout;
